module.exports = __webpack_public_path__ + "img/QR_gzh.1fefbf1c.png";